export default __webpack_public_path__ + "img/3c4988ac575ac9f3d7b6a40c681d6cb1.svg";